<template>
  <div @click="renderChart()" class="chart-container">
    <div class="chart-container-header">
      <div class="title">
        {{
          datatype == "traffic"
            ? $t("stats_chart.conversion")
            : $t("stats_chart.title")
        }}
      </div>
      <div class="mode-slider">
        <div
          @click="ChangeMode('day')"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'day' }"
        >
          {{ $t("stats_chart.day") }}
        </div>
        <div
          @click="ChangeMode('week')"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'week' }"
        >
          {{ $t("stats_chart.week") }}
        </div>
        <div
          @click="ChangeMode('month')"
          v-if="canShowMonthTab"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'month' }"
        >
          {{ $t("stats_chart.month") }}
        </div>
      </div>
    </div>
    <div class="chart-data-container">
      <div class="vertical-numeration">
        <div class="number" v-for="i in verticalMaxValue" :key="i">
          {{ getVerticalEntry(i) }}
        </div>
        <!-- <div class="number">0</div> -->
      </div>
      <div class="chart-bg">
        <div
          id="chart-columns"
          :class="{
            'chart-columns': true,
            'week-mode': mode == 'week',
            'month-mode': mode == 'month',
          }"
          :style="`width:${
            columnWidth * (processedDataset[0].coordinates.length - 1)
          }vh`"
        >
          <canvas
            :class="{
              'week-canvas': mode == 'week',
              'month-canvas': mode == 'month',
            }"
            id="canvas"
            ref="canvas"
          ></canvas>
          <div
            v-for="(el, index) in processedDataset[0].coordinates"
            :key="index"
            @mouseover="showCircles(index)"
            @mouseleave="selectedCoordinate = null"
            :class="{
              'vertical-column': true,
              'week-mode': mode == 'week',
              'month-mode': mode == 'month',
            }"
            :style="{
              width: `calc(100% / ${datasetLength})`,
            }"
          >
            <div class="info-panel">
              <div v-if="datatype == 'orders'">
                <div
                  v-for="el in processedDataset"
                  :key="el.label"
                  class="info-block"
                >
                  <div :style="`color:${el.color}`" class="info-label">
                    {{ el.label }}
                  </div>
                  <div
                    v-if="selectedCoordinate || selectedCoordinate == 0"
                    class="value"
                  >
                    {{ el.coordinates[selectedCoordinate].coordinate }}
                  </div>
                </div>
              </div>
              <div v-else>
                <!-- <div class="info-title">КІЛЬКІСТЬ ПЕРЕХОДІВ</div> -->
                <div
                  v-for="el in processedDataset"
                  :key="el.label"
                  class="info-block"
                >
                  <!-- <img class="icon" src="/icons/add-icon.svg" />
                  <div
                    v-if="selectedCoordinate || selectedCoordinate == 0"
                    class="value"
                  >
                    {{ el.coordinates[selectedCoordinate].coordinate }}
                  </div> -->
                  <div :style="`color:${el.color}`" class="info-label">
                    {{ el.label }}
                  </div>
                  <div
                    v-if="selectedCoordinate || selectedCoordinate == 0"
                    class="value"
                  >
                    {{ el.coordinates[selectedCoordinate].coordinate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="vertical-dashed-line"></div>
            <div
              class="day-label"
              :class="{
                'day-off': el.is_weekday,
              }"
            >
              {{ el.label }}
            </div>
            <div class="day-date">{{ el.date }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
function hexToRgbA(hex, force_alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      `,${force_alpha})`
    );
  }
  throw new Error("Bad Hex");
}

const CHART_SPACE_RATIO = 1.2;

import moment from "moment";

export default {
  data() {
    return {
      mode: "day",
      info_style: "default",
      staff: [
        {
          label: "INSIDE",
          color: "#129B81",
          bgcolor: "rgba(18, 155, 129, 0.3)",
          coordinates: [
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
            { label: "Пн", date: "12.02", coordinate: 7 },
            { label: "Пн", date: "12.02", coordinate: 90 },
            { label: "Пн", date: "12.02", coordinate: 28 },
          ],
        },
        {
          label: "TAKEAWAY",
          color: "#FFD2A8",
          bgcolor: "#ffd2a853",
          coordinates: [
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 54 },
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 50 },
          ],
        },
        {
          label: "RESERVE",
          color: "#AECCC6",
          bgcolor: " rgba(174, 204, 198, 0.3)",
          coordinates: [
            { label: "Пн", date: "12.02", coordinate: 50 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 0 },
            { label: "Пн", date: "12.02", coordinate: 23 },
            { label: "Пн", date: "12.02", coordinate: 23 },
          ],
        },
      ],
      staff2: [
        {
          label: "INSIDE",
          color: "#129B81",
          bgcolor: "rgba(18, 155, 129, 0.3)",
          coordinates: [
            { label: "Пн", date: "01.04 - 07.04", coordinate: 28 },
            { label: "Пн", date: "01.04 - 07.04", coordinate: 7 },
            { label: "Пн", date: "01.04 - 07.04", coordinate: 90 },
            { label: "Пн", date: "01.04 - 07.04", coordinate: 53 },
          ],
        },
      ],
      staff3: [
        {
          label: "INSIDE",
          color: "#129B81",
          bgcolor: "rgba(18, 155, 129, 0.3)",
          coordinates: [
            { label: "Грудень", date: "2021", coordinate: 28 },
            { label: "Лютий", date: "2021", coordinate: 7 },
          ],
        },
      ],
      selectedCoordinate: null,
      failedToRender: false
    };
  },
  watch: {
    selectedCoordinate() {
      this.$nextTick(this.renderChart);
    },
    mode() {
      this.$nextTick(this.renderChart);
    },
    datasets() {
      this.$nextTick(this.renderChart);
    },
  },
  props: {
    datasets: Object,
    datatype: {
      type: String,
      default: "orders",
    },
    noBackground: {
      type: Boolean,
      default: false
    },
    range: Object
  },
  mounted() {
    this.$nextTick(this.renderChart);
  },
  methods: {
    showCircles(i) {
      this.selectedCoordinate = i;
    },
    getModeColor(mode) {
      return {
        inside: "#129b81",
        preorder: "#FFD2A8",
        delivery: "#aeccc6",
        reserve: "#aeccc6",
        orders: "#129b81",
        views: "#908f8d",
        bounce: "#ededed",
      }[mode];
    },
    ChangeMode(mode) {
      this.mode = mode;
    },
    renderChart() {
      this.renderDataset(this.processedDataset);
    },
    renderDataset(dataset) {
      console.log(this.verticalMaxValue, this.maxValue, this.$refs.canvas);
      const canvas = this.$refs.canvas;
      if (!canvas) {
        if (!this.failedToRender) this.$nextTick(this.renderChart);
        this.failedToRender = true;
        return;
      }
      const ctx = canvas.getContext("2d");

      //resetup canvs context
      ctx.canvas.height = canvas.offsetHeight * 4;
      ctx.canvas.width = canvas.offsetWidth * 4;

      const height = ctx.canvas.height;
      const width = ctx.canvas.width;

      //determine step
      let wstep = (canvas.offsetWidth / (this.datasetLength - 1)) * 4;
      // if (this.mode == 'day') {
      //   wstep = canvas.offsetWidth / 30;
      // } else if (this.mode == 'week') {
      //   wstep = canvas.offsetWidth / 3;
      // } else {
      //   wstep = canvas.offsetWidth;
      // }

      const max_valued_height = height;

      const hstep = (height * 0.8) / this.maxValue;

      console.log(wstep, hstep);

      const left_padding = wstep / 2;

      //draw dashed lines at center of each column
      for (let l = 0; l < this.datasetLength; l++) {
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.setLineDash([15, 9]);
        ctx.strokeStyle = l == this.selectedCoordinate ? "#ededed" : "#908f8d";
        ctx.moveTo(l * wstep, 0);
        ctx.lineTo(l * wstep, ctx.canvas.height);
        ctx.stroke();
        ctx.closePath();
        ctx.setLineDash([]);
      }

      //iterate every series in dataset
      for (let j = 0; j < dataset.length; j++) {
        ctx.beginPath();

        if (!dataset[j].hidden)
          for (let i = 0; i < dataset[j].coordinates.length; i++) {
            if (i == 0) {
              ctx.moveTo(
                0,
                max_valued_height - dataset[j].coordinates[i].coordinate * hstep
              );
              ctx.lineTo(
                wstep * (i + 1),
                max_valued_height - dataset[i + 1] * hstep
              );
            } else if (i == dataset[j].coordinates.length - 1) {
              ctx.lineTo(
                wstep * (i + 1),
                max_valued_height - dataset[j].coordinates[i].coordinate * hstep
              );
            } else {
              ctx.lineTo(
                wstep * i,
                max_valued_height - dataset[j].coordinates[i].coordinate * hstep
              );
            }
          }
        ctx.lineWidth = 12;
        ctx.strokeStyle = dataset[j].color;
        ctx.stroke();
        if (dataset[j].bgcolor && !this.noBackground) {
          ctx.fillStyle = dataset[j].bgcolor;
          ctx.lineTo(
            (dataset[j].coordinates.length - 1) * wstep,
            max_valued_height
          );
          ctx.lineTo(0, max_valued_height);
          ctx.lineTo(
            0,
            max_valued_height - dataset[j].coordinates[0].coordinate
          );
          ctx.globalCompositeOperation = "destination-over";
          ctx.fill();
          ctx.globalCompositeOperation = "source-over";
        }
        // if (this.selectedCoordinate || this.selectedCoordinate == 0) {
        //   ctx.beginPath();

        //   ctx.fillStyle = dataset[j].color;
        //   ctx.arc(
        //     wstep * this.selectedCoordinate,
        //     ctx.canvas.height -
        //       dataset[j].coordinates[this.selectedCoordinate].coordinate * hstep,
        //     height / 30,
        //     0,
        //     2 * Math.PI
        //   );
        //   ctx.fill();
        //   ctx.stroke();
        // }
      }

      if (this.selectedCoordinate || this.selectedCoordinate == 0) {
        for (let j = 0; j < dataset.length; j++) {
          if (
            dataset[j].hidden ||
            !dataset[j].coordinates[this.selectedCoordinate].coordinate
          )
            continue;
          ctx.beginPath();
          ctx.strokeStyle = dataset[j].color;
          ctx.fillStyle = dataset[j].color;
          ctx.arc(
            wstep * this.selectedCoordinate,
            max_valued_height -
              dataset[j].coordinates[this.selectedCoordinate].coordinate *
                hstep,
            height / 30,
            0,
            2 * Math.PI
          );
          ctx.fill();
          ctx.stroke();
        }
      }
      ctx.scale(4, 4);
    },
    getVerticalEntry(i) {
      let decimal_ratio = this.maxValue < 10 ? 10 : 1;
      return Math.round(
        this.maxValue / 10 * (this.verticalMaxValue - i) * decimal_ratio
        // this.verticalMaxValue - (i - 1) * (this.verticalMaxValue / 10)
      ) / decimal_ratio;
    },
  },
  computed: {
    columnWidth() {
      if (this.mode == "day") return 5.5;
      if (this.mode == "week") return 11;
      if (this.mode == "month") return 35;
    },
    targetDataset() {
      return this.datasets[this.mode];
    },
    maxValue() {
      return this.targetDataset.reduce(
        (mx, it) =>
          Math.max(
            mx,
            it.inside || 0,
            it.preorder || 0,
            it.delivery || 0,
            it.reserve || 0,
            this.datatype == "traffic" ? it.orders || 0 : 0,
            this.datatype == "traffic" ? it.views || 0 : 0
          ),
        1
      );
    },
    datasetLength() {
      return this.targetDataset.length;
    },
    canShowMonthTab() {
      return moment(this.range.end).diff(this.range.start, 'months') > 1;
    },
    processedDataset() {
      const modes =
        this.datatype == "traffic"
          ? ["orders", "views", "bounce"]
          : ["inside", "preorder", "delivery", "reserve"];

      return modes.map((m) => {
        return {
          label:
            this.datatype == "traffic"
              ? this.$t(`stats_chart.label_${m}`)
              : m.toUpperCase(),
          color: this.getModeColor(m),
          hidden: m == "bounce",
          bgcolor: hexToRgbA(this.getModeColor(m), 0.3),
          coordinates: this.targetDataset.map((d) => {
            let label = "";
            let date = "";

            if (this.mode == "day") {
              label = moment(d.timestamp).format("ddd");
              date = moment(d.timestamp).format("DD.MM");
            } else if (this.mode == "week") {
              label = moment(d.timestamp).format("ddd");
              date =
                moment(d.timestamp).startOf("week").format("DD.MM") +
                " - " +
                moment(d.timestamp).endOf("week").format("DD.MM");
            } else if (this.mode == "month") {
              label = moment(d.timestamp).format("MMM");
              date =
                moment(d.timestamp).format("DD.MM") +
                " - " +
                moment(d.timestamp).endOf("month").format("DD.MM");
            }

            const label_day = moment(d.timestamp).day();

            return {
              label,
              is_weekday:
                this.mode == "day" && (label_day == 0 || label_day == 6),
              date,
              coordinate: d[m] || 0,
            };
          }),
        };
      });
    },
    verticalMaxValue() {
      const mx = this.maxValue || 0;

      const return_value = Math.min(12, mx * CHART_SPACE_RATIO);

      return Math.round(return_value);
    },
  },
};
</script>
<style scoped>
.chart-container {
  width: 100%;
  padding: 2.222vh;
  background: #e5e5e5;
  border-radius: 1.333vh;
  margin-top: 3.333vh;
  box-sizing: border-box;
}
.chart-container-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.777vh;
  line-height: 3.222vh;
  display: flex;
  align-items: center;
  color: #908f8d;
}
.mode-slider {
  height: 3.666h;
  background: #ededed;
  border-radius: 0.444vh;
  display: flex;
}
.mode-slide-btn {
  width: 17.444444444444443vh;
  height: 3.666vh;
  border-radius: 0.444vh;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active-mode {
  background: #1d1d1b;
  color: #ededed;
}
.chart-data-container {
  width: 100%;
  position: relative;
  box-sizing: border-box;
}
#canvas {
  width: calc(100% - 4.888888888888889vh);
  height: 27.8vh;
  position: absolute;
  pointer-events: none;
  margin: 0 2.4444444444444446vh 0;
  z-index: 2;
}
#canvas.week-canvas {
  width: calc(100% - 8.888888888888vh);
  margin: 0 4.444444444444445vh 0 !important;
}
#canvas.month-canvas {
  width: calc(100% - 8.888888888888vh);
  margin: 0 4.444444444444445vh 0 !important;
}
.chart-bg {
  width: 100%;
  overflow-x: auto;
  position: relative;
  padding-left: 4.7vh;
  padding-right: 1px;
  box-sizing: border-box;
}
.vertical-numeration {
  width: 4.2vh;
  height: 37.2vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  left: 0;
  background: #e5e5e5;
  z-index: 3;
  padding-right: 1vh;
}
.chart-columns {
  min-width: 97.13%;
  height: 100%;
  display: flex;
  position: relative;
  justify-content: space-between;
  padding-top: 1.6666666666666667vh;
}
/* .chart-columns.week-mode {
  padding: 0 4.93%;
  justify-content: space-between;
} */
/* .chart-columns.month-mode {
  padding: 0 24.24%;
  justify-content: space-between;
} */
.vertical-column {
  position: relative;
  margin-top: -1.6666666666666667vh;
  height: 37vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 1.5555555555555556vh 0 0.8888888888888888vh 0;
  cursor: pointer;
  max-width: 4.888888888888889vh;
}
.vertical-column.week-mode {
  max-width: 8.88888888888889vh;
}
.vertical-column.month-mode {
  max-width: 8.88888888888889vh;
}
.vertical-column:hover {
  border-radius: 0.5555555555555556vh;
  background: #1d1d1b;
}
.vertical-column:hover .day-label {
  color: #ededed;
}
.vertical-column:hover .vertical-dashed-line {
  /* border-color: #ededed; */
}
.vertical-column:hover .info-panel {
  display: block;
  left: 125%;
}
.vertical-column:last-child:hover .info-panel {
  display: block;
  left: -200%;
}
.vertical-column:nth-last-child(2):hover .info-panel {
  display: block;
  left: -200%;
}
.vertical-column.week-mode:last-child:hover .info-panel {
  display: block;
  left: -125%;
}
.vertical-column.week-mode:nth-last-child(2):hover .info-panel {
  display: block;
  left: -125%;
}
.vertical-column.month-mode:last-child:hover .info-panel {
  display: block;
  left: -125%;
}
.vertical-column.month-mode:nth-last-child(2):hover .info-panel {
  display: block;
  left: 125%;
}
.vertical-dashed-line {
  height: 27.8vh;
  /* border-right: 1px dashed #908f8d; */
  margin-bottom: 1.7777777777777777vh;
}
.number {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  text-align: right;
  color: #908f8d;

  width: 100%;
}
.number:first-child {
  margin-top: 0.5555555555555556vh;
}
.number:last-child {
  margin-bottom: 6.8vh;
}
.day-label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  text-align: center;
  color: #1d1d1b;
  width: 100% !important;
}
.day-label.day-off {
  color: #e2223b;
}
.day-date {
  font-size: 1.1111111111111112vh;
  line-height: 1.3333333333333333vh;
  color: #908f8d;
  width: 100% !important;
  text-align: center;
}
.info-panel {
  width: max-content;
  display: none;
  position: absolute;
  top: calc(40% - 50px);
  background: #1d1d1b;
  box-shadow: 4px 4px 7px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(15px);
  border-radius: 0.8888888888888888vh;
  z-index: 2;
  padding: 1.1111111111111112vh;
}
.circle {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: red;
}
.info-label {
  font-size: 1.1111111111111112vh;
  line-height: 1.3333333333333333vh;
}
.value {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #ededed;
}
.info-block {
  margin-bottom: 1.1111111111111112vh;
}
.info-block:last-child {
  margin-bottom: 0;
}
.info-title {
  font-size: 1.1111111111111112vh;
  line-height: 1.3333333333333333vh;
  color: #908f8d;
  margin-bottom: 1.1111111111111112vh;
  width: max-content;
}
.icon {
  width: 2vh;
  height: 2vh;
  margin-right: 0.5555555555555556vh;
}
.trafic-info {
  display: flex;
  align-items: center;
  margin-bottom: 0.5555555555555556vh;
}
.trafic-info:last-child {
  margin-bottom: 0;
}
</style>
